import { Component, Input } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { Cumulated } from "src/app/shared/jsonrpc/response/queryHistoricTimeseriesEnergyResponse";
import { EdgeConfig,Utils } from "src/app/shared/shared";
import { DefaultTypes } from "src/app/shared/type/defaulttypes";

@Component({
  selector: "ReducedGas",
  templateUrl: "./reducedgas.html",
  standalone: false,
})
export class ReducedEmissionComponent extends AbstractFlatWidget
{
  @Input() public period: DefaultTypes.HistoryPeriod;

  public data: Cumulated = null;
  public chargerComponents: EdgeConfig.Component[] = [];
  public productionMeterComponents: EdgeConfig.Component[] = [];
  public readonly CONVERT_WATT_TO_KILOWATT = Utils.CONVERT_WATT_TO_KILOWATT;
  public readonly CONVERT_WATT_TO_KG = Utils.CONVERT_WATT_TO_KG;
}
